import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../store";

// Define a type for the slice state
interface CertificateState {
  certificate: string;
  formationId: number;
}

// Define the initial state using that type
const initialState: CertificateState = {
  certificate: "",

  formationId: 0,
};

export const certificateSlice = createSlice({
  name: "certificate",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setCertificate: (state, action: PayloadAction<string>) => {
      state.certificate = action.payload;
    },
    setFormationId: (state, action: PayloadAction<number>) => {
      state.formationId = action.payload;
    },
  },
});

export const { setCertificate, setFormationId } = certificateSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const getCertificate = (state: RootState) => state.certificate;
export default certificateSlice.reducer;
